<template lang="pug">
.label_cmp
  .radio_line
    el-radio(v-model="rTp" label="1" class="first") 行业推荐
    span.line
    el-radio(v-model="rTp" label="2") 自定义标签
  .cmn_ctn
    el-form(v-if="rTp == 1")
      el-form-item(label="我的行业" style="background: #fff;margin-bottom: 0;")
        el-popover(
          placement="bottom" trigger="click" popper-class="indus_pop"
          @show="showPop = !showPop" @hide="showPop = !showPop"
        )
          .indus(slot="reference")
            span.fl.els(:class="{ 'no_data': timeStr == '不限' }") {{ timeStr }}
            i.fr.el-icon-arrow-down(:class="{ 'up': showPop }")
          .list_ctn
            .indus_item(v-for="item in indusList" :key="item.name")
              .name {{ item.name }}
              .list(v-if="item.list.length")
                .item(v-for="it in item.list" :key="it.name" :class="{ 'check': it.check }" @click="checkItemClick(it)") {{ it.name }}

    //- 暂时隐藏行业推荐 把 CommonLabels 移出来  之后  CommonLabels 缩进回去就行   rTp 改为默认 1
    CommonLabels(v-model="commonLabelData" v-if="rTp == 2" @profileChange="profileChange" ref="commonLabelRef")
</template>

<script>
export default {
  name: 'LabelCmp',
  components: { CommonLabels: () => import('@/views/PutOrder/components/OrderForm/CommonLabels.vue') },
  data () {
    return {
      commonLabelData: [],
      rTp: '',

      showPop: false,
      indusList: [], // 行业列表
      timeStr: '不限',
      multChoose: false // 是否多选
    }
  },
  async created () {
    this.indusList = await this.rsIndusList()
    this.rTp = '1' // 初始化选中行业
  },
  watch: {
    rTp (v) {
      if (v == 1) {
        this.commonLabelData = [] // 切换到行业时 清空commonLabel的数据
        this.profileChange([])
        this.$nextTick(() => {
          // rTp为1时应为行业 上面 commonLabelData = [] 会触发 watch的 异步更新 导致重置为common 确保为 indus 为行业 这里须加入到异步执行队列 $nextTick 回调中执行
          this.$emit('change', [], 'indus')
        })
      } else if (v == 2) {
        this.clearIndus()
        this.$nextTick(() => {
          this.$emit('change', [], 'common')
        })
      }
    },
    commonLabelData (v) {
      this.$emit('change', v, 'common')
    }
  },
  methods: {
    checkItemClick (it) {
      let oc = it.check
      if (!this.multChoose) { // 单选时取消其他的选中状态
        this.indusList.forEach(el => {
          el.list.forEach(ele => {
            if (ele.check) ele.check = false
          })
        })
      }
      it.check = !oc

      let arr = this.indusList.filter(el => el.list.filter(ele => ele.check).length)
      let chs = arr.map(el => {
        return {
          ...el, chooses: el.list.filter(ele => ele.check).map(ele => ({...ele}))
        }
      })
      this.$emit('change', chs, 'indus')
      this.rsIndusShow(chs)
    },

    rsIndusShow (chs) {
      let res = chs.map(el => {
        let { name, chooses } = el
        return `${name}(${chooses.map(ele => ele.name).join(',')})`
      }).join(',')
      this.timeStr = res || '不限'
    },
    async rsIndusList () {
      let storeOrder = this.$store.state.order
      if (!storeOrder.industryList.length) await this.$store.dispatch('order/getIndustryList')
      return storeOrder.industryList.map(el => {
        return { ...el, list: (el.subIndustries || []).map(ele => ({ ...ele, check: false })) }
      })
    },
    profileChange (data) {
      this.$emit('change', data, 'profile')
    },
    clearIndus () { // 清空行业选择数据
      this.$emit('change', [], 'indus')
      this.rsIndusShow([])
      this.indusList.forEach(el => {
        el.list.forEach(ele => ele.check = false)
      })
    },
    init () {
      this.rTp = '1'
      this.clearIndus() // 行业重置
      this.$refs.commonLabelRef && this.$refs.commonLabelRef.init() // 标签重置
    }
  }
}
</script>

<style lang="scss">
.indus_pop {
  overflow: auto;
  padding: 15px 0;
  border: 1px solid #282729;
  width: 320px;
  height: 360px;
  text-align: center;
  transform: translate(-44px, 0);
}
</style>

<style lang="scss" scoped>
.list_ctn {
  width: 280px;
  margin: 0 auto;
  text-align: left;
  .indus_item {
    margin-bottom: 10px;
  }
  .name {
    color: #282729;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }
  .list {
    overflow: hidden;
  }
  .item {
    float: left;
    min-width: 90px;
    padding: 0 10px;
    height: 30px;
    line-height: 28px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #D4D4D4;
    font-size: 12px;
    color: #666;
    margin-right: 5px;
    margin-bottom: 5px;
    text-align: center;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.check {
      border: 1px solid #282729;
    }
  }
}
.label_cmp {
  background: #FBFBFB;
  border-radius: 4px;
  border: 1px solid #E9E9E9;
  .radio_line {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #E9E9E9;
    padding-left: 10px;
    ::v-deep .el-radio {
      .el-radio__label {
        color: #4B4F58;
      }
    }
  }
  .cmn_ctn {
    padding: 10px;
  }
}
.indus {
  float: right;
  width: calc(100% - 68px);
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  span {
    width: 180px;
    display: inline-block;
    padding-left: 10px;
  }
  .no_data {
    color: #aaa;
    font-size: 12px;
  }
  i {
    margin-left: 4px;
    margin-right: 10px;
    margin-top: 9px;
    color: #C0C4CC;
    &.up {
      transform: rotate(180deg);
    }
  }
}
</style>
